// removed by extract-text-webpack-plugin
module.exports = {"detail":"NMxTh _1-OXK _3Xg8b _1Q5o6","detailBody":"b7fVx _3_vf0","detailTitle":"_2pcEN _1v96X Md4ty","detailSubtitle":"_1VmG4 _2QXSI _1sS2g _2e0tB","detailSubtitleLight":"_2wiNM _1sS2g _2e0tB","detailTextarea":"_1g6Z8 _2QXSI _1bHiY _2Eplg"};


//////////////////
// WEBPACK FOOTER
// ./reference/components/Detail.css
// module id = 544
// module chunks = 3